// eslint-disable-next-line max-len
export const HEADER_DESCRIPTION = 'The Rockerbox scenario planner allows you to explore different marketing scenarios, where you may be looking to expand, contract or reallocate budget subject to different constraints. The goal of scenario planning use the Marketing Mix Model to understand the impact of different budget allocations on your marketing performance.';

export const tableColumnOptions = [
  { value: 'baseline', icon: 'window minimize' },
  { value: 'delta', icon: 'percent' },
  { value: 'totalPercent', icon: 'chart pie' },
];

export const OPTIMIZATION_OPTIONS = {
  maxKPIs: 'max_kpi',
  reduceBudget: 'reduce_budget',
  expandBudget: 'expand_budget',
  targetMetric: 'target_metric',
};

export const KPI_METRIC_TEXT = {
  conversions: 'conversions',
  revenue: 'revenue',
  CPA: 'CPA',
  ROAS: 'ROAS',
};

export const BASELINE_ROW_KEY = 'baseline_';
